//
/* GS://PROTOCOLO
 * * Arquivo: src/firebase/config.js
 * * Versão: 1.3 – FIX: Estabilidade de Conexão Firestore v10
 * * Data: 28/12/2025
 * * Responsável: IA
 * * Mudanças:
 * * - [FIX]: Substituído getFirestore por initializeFirestore para estabilidade de conexão.
 */
//

import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore'; // MODIFICADO: Importação ajustada para v10
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyDGk4y5Twzek4krprRMvBowrA32U1Ptt5Q",
    authDomain: "goldensisters-premium.firebaseapp.com",
    projectId: "goldensisters-premium",
    storageBucket: "goldensisters-premium.firebasestorage.app",
    messagingSenderId: "967132682608",
    appId: "1:967132682608:web:58bf40c9bd3299a5ae97b5",
    measurementId: "G-HY8JL3TZKC"
};

const app = initializeApp(firebaseConfig);

// [GS-CORRECAO]: Uso de initializeFirestore para garantir configurações estáveis na v10
const db = initializeFirestore(app, {
    // Configurações padrão explícitas para evitar timeouts de conexão em dev
});

const storage = getStorage(app);
const auth = getAuth(app);
// [GS-CORRECAO]: Define a região correta para conectar com o backend
const functions = getFunctions(app, 'southamerica-east1');

export { app, db, storage, auth, functions };